<template>
    <div>
        <md-field>
            <label>{{labelText}}</label>
            <TbSelect v-model="value" md-dense
					  :options="options"
					  options-value-field="value"
					  options-display-field="displayValue"
					  ref="select"
			/>
        </md-field>
    </div>
</template>
<script>

export default {
    props: {
        labelText: { type: String },
        columnName: { type: String },
        initialValue: { type: Boolean, default: null }
    },
    data() {
        return {
            value: this.initialValue,
			options: [
				{ value: -1, displayValue: this.$t("common.all") },
				{ value: true, displayValue: this.$t("common.yes") },
				{ value: false, displayValue: this.$t("common.no") },
			]
        };
    },
    methods: {
        clearFilter() {
            this.value = null;
        },
        getFilter() {
            if (this.value === null || this.value === -1) {
                return null;
            }

            return [{
                columnName: this.columnName,
                fieldType: "B",
                matchType: "EQ",
                value: this.value
            }];
        },
        setFilter(filter) {
            this.value = filter.value;
        }
    },
};
</script>
